import { render, staticRenderFns } from "./messagesFilter.vue?vue&type=template&id=53c98053"
import script from "./messagesFilter.vue?vue&type=script&lang=js"
export * from "./messagesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports